import { FiltersInPricesValues } from '@/domain/prices/filters/types'
import { useIntl } from '@/intl'
import { PricesUseCasesContext } from '@/scopes/prices/components/context'
import {
  getPricesSelector,
  monthFilterOptionsSelector,
} from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { Button, Icon, SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled(SpaceBetween)`
  display: flex;
  align-items: center;
  justify-content: end;

  ${Button} {
    ${Button.modSize('small')}
  }

  ${Typography} {
    color: ${tk('color_semantic_text_subdued')};
  }
`

export function NavigationNew() {
  const intl = useIntl()
  const { selectFilter } = React.useContext(PricesUseCasesContext)
  const { loading } = usePricesSelector(getPricesSelector)

  const setSelection = (selection: FiltersInPricesValues) => selectFilter({ type: 'Month', selection })

  const { options, selectedValue } = usePricesSelector(monthFilterOptionsSelector)

  const isFirstMonth
    = selectedValue !== undefined && selectedValue === options[0]?.value
  const isLastMonth
    = selectedValue !== undefined
      && selectedValue === options[options.length - 1]?.value

  const goToNextMonth = () => {
    if (selectedValue === undefined)
      return
    const nextMonthIndex = options.findIndex(month => month.value === selectedValue) + 1
    setSelection(options[nextMonthIndex]?.value)
  }

  const goToPreviousMonth = () => {
    if (selectedValue === undefined)
      return
    const previousMonthIndex
      = options.findIndex(month => month.value === selectedValue) - 1
    setSelection(options[previousMonthIndex]?.value)
  }

  return (
    <Wrapper direction="x" spacing={tk('spacing_md')}>
      <Button $hierarchy="secondary" $withoutColor onClick={goToPreviousMonth} disabled={loading || isFirstMonth}>
        <Icon glyph="IconChevronLeft" />
      </Button>
      <Typography $variant="label-thin">{intl.formatMessage({ id: 'prices_filters_month_navigation' })}</Typography>
      <Button $hierarchy="secondary" $withoutColor onClick={goToNextMonth} disabled={loading || isLastMonth}>
        <Icon glyph="IconChevronRight" />
      </Button>
    </Wrapper>
  )
}
